export const DEFAULT_VIDEO_ASPECT_RATIO: string = '16 / 9';
